export default __webpack_public_path__ + "static/media/home-restaurant-img-14.2859b1dc.jpg";